export default {
  modal: {
    // [data-placeholder="xx"] permet d'afficher un bloc
    // gris si le contenu de la balise associée est vide
    title: 'Votre fidélité récompensée',
    points: `
      À chaque commande livrée, vous cumulez des miams.
      <br/>
      <b>1€ dépensé et vous gagnez <span data-placeholder="x">%{coefficient}</span> miams.</b>
    `,
    rewards: `
      Au bout de <b><span data-placeholder="xxxx">%{threshold}</span> miams</b>, M.Miam vous
      récompense et ajoutera dans votre prochaine commande <b>un produit surprise</b> !
      <br/>
      Vous pouvez retrouver le cumul de vos miams dans votre compte.
    `,
    button: 'Voir mes miams',
  },
  banner: {
    cart: {
      media: '+%{miams}<br/>MIAMS',
      message: {
        '0-50': 'C’est parti ! Une surprise offerte tous les %{threshold} miams.',
        '50-80': 'Plus que %{toReward} miams pour gagner votre surprise.',
        '80-100':
          'Plus que %{toReward} miams pour gagner votre surprise. Encore quelques articles et ça sera bon.',
        '100+':
          'Bravo, vous allez dépasser les %{threshold} miams avec cette commande. Une surprise offerte dans la prochaine.',
        'gift': 'Bravo, vous aurez un cadeau offert avec cette commande. Ouvrez l’oeil.',
        'unknown': 'C’est parti ! Une surprise offerte tous les %{threshold} miams.',
      },
    },
    gains: {
      media: 'MIAMS',
      title: 'FÉLICITATIONS !',
      message: 'Une fois votre commande livrée, ces miams seront crédités sur votre compte.',
    },
    progress: {
      '0-20': {
        title: 'C’est parti',
        message:
          'Vous avez cumulé <b>%{miams} miams</b>. Chaque euro vous rapproche du cadeau à %{threshold} miams.',
      },
      '20-50': {
        title: 'En chemin',
        message:
          'Vous avez cumulé <b>%{miams} miams</b>. Vous avancez bien. Le goût de la récompense approche.',
      },
      '50-80': {
        title: 'Continuez comme ça',
        message:
          'Vous tenez le rythme. Plus que <b>%{toReward} miams</b> et votre surprise sera à vous.',
      },
      '80-100': {
        title: 'Tout près',
        message:
          'La récompense est presque là : plus que <b>%{toReward} miams</b> et votre surprise sera à vous.',
      },
      '100+': {
        title: 'Gagné',
        message:
          '<b>%{threshold} miams</b> atteints : un cadeau vous attendra dans votre prochaine commande.',
      },
    },
  },
  box: {
    points: {
      text: 'Grâce à cette commande, vous avez cumulé <b>%{miams} miams</b>.',
    },
    product: {
      text: 'Grâce à vos miams, <b>une surprise</b> s’est glissée dans cette commande.',
    },
    donation: {
      text: 'Vous avez utilisé vos miams pour faire un don de <b>%{amount}</b> à %{charity}',
      charity: 'une association',
    },
    surprise: {
      text: 'Youpiii, cette commande vous permet de débloquer votre <b>cadeau</b>.',
    },
  },
};
